<!-- <ng-template #confirmationModal let-c="close" let-d="dismiss"> -->
<div class="modal-header">
  <h5 class="" id="modal-title">
    Update of the Calculation is Required
  </h5>
  <div class="loading" *ngIf="xmlloader">Loading&#8230;</div>
  <button type="button" class="close" aria-describedby="modal-title"
    (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
 
</div>
<div class="modal-body">
  <label class="block">The selected calculation is an old version and must be updated.</label>
  <label class="block">If you open the calculation it will be updated to the latest version and the calculation results may change.</label>
  <label *ngIf="isReportAvailable" class="block">
    You can still download the old report files.
  </label>
</div>
<div class="modal-footer">
  <button type="button" *ngIf="isReportAvailable" class="btn btn-warning float-left" (click)="DownloadReport()">
    Download Report(s)
  </button>
  <button type="button" class="btn btn-default ml-auto" (click)="activeModal.dismiss(false)">
    Close
  </button>
  <button type="button" class="btn btn-primary" (click)="updatexml()">
    Update
  </button>
</div>
<!-- </ng-template> -->